<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <span class="pagination-container__current">
      当前在第<span class="pagination-container__current--page">{{ currentPage }}</span
      >页
    </span>
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layoutOpt"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
  import { scrollTo } from "@/utils/scroll-to";

  export default {
    name: "Pagination",
    props: {
      total: {
        // required: true,
        type: Number,
        default: null,
      },
      page: {
        type: Number,
        default: 1,
      },
      limit: {
        type: Number,
        default: 20,
      },
      pageSizes: {
        type: Array,
        default() {
          return [10, 20, 30, 50, 100];
        },
      },
      layout: {
        type: String,
        default: "total, sizes, prev, pager, next, jumper",
      },
      background: {
        type: Boolean,
        default: true,
      },
      autoScroll: {
        type: Boolean,
        default: true,
      },
      hidden: {
        type: Boolean,
        default: false,
      },
      hidePager: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      currentPage: {
        get() {
          return this.page;
        },
        set(val) {
          this.$emit("update:page", val);
        },
      },
      pageSize: {
        get() {
          return this.limit;
        },
        set(val) {
          this.$emit("update:limit", val);
        },
      },
      layoutOpt() {
        return this.hidePager ? "total, sizes, prev, next" : this.layout;
      },
    },
    methods: {
      handleSizeChange(val) {
        this.$emit("pagination", { page: this.currentPage, limit: val });
        if (this.autoScroll) {
          scrollTo(0, 800);
        }
      },
      handleCurrentChange(val) {
        this.$emit("pagination", { page: val, limit: this.pageSize });
        if (this.autoScroll) {
          scrollTo(0, 800);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .pagination-container {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px 0;
    &__current {
      font-weight: normal;
      color: #606266;
      font-size: 13px;
      &--page {
        color: #1890ff;
      }
    }
  }
  .pagination-container.hidden {
    display: none;
  }
</style>
